// Text.jsx
import React from "react";
import { findKeyByEnValue, getTranslationByKey } from "../utils/useText.ts";
import { useSelector } from "react-redux";



const Text = ({ children, page, className }) => {

  const defaultLanguage = useSelector((state) => state.settings.defaultLanguage);

  try {
    const key =findKeyByEnValue(children, true, page) ? findKeyByEnValue(children, true, page) : children;
  const text = getTranslationByKey(key, defaultLanguage,page);
  return <>{text}</>;
  } catch (error) {
    console.warn(`Translation not found for "${children}" in page "${page}"`);
    return <span className={className}>{children}</span>;
  }
};

export default Text;
